import Cookies from 'js-cookie'
export default function setLocalStorage (data){
    window.localStorage.setItem("token", data.access_token);
    window.localStorage.setItem("token_type", data.token_type);
    window.localStorage.setItem("refresh_token", data.refresh_token);
    window.localStorage.setItem("expir", data.expires_in);
    window.localStorage.setItem("cookieTimer", new Date().getTime()||"");
    Cookies.set("token", data.access_token)

}